import DropdownItem from '../DropdownItem'
import { ItemsList } from '@insided/deprecated-preact-components/dropdown/interfaces'

interface GroupedItemListProps {
  groupName: string
  key: string
  items: ItemsList
}

const GroupedItemList = ({ groupName, items, key }: GroupedItemListProps) =>
  <div className='control-dropdown__list--grouped' key={key}>
    <div className='control-dropdown__list--group-name'>{groupName}</div>
    {items.map(item =>
      <DropdownItem
        title={item.title}
        key={item.value}
        onClick={item.onClick}
        value={item.value}
        image={item.image}
      />
    )}
  </div>

export default GroupedItemList
